import { computed, useRoute } from '@nuxtjs/composition-api';

export function usePreviewMode() {
  const route = useRoute();

  return {
    isPreviewMode: computed(() => Boolean(route.value.query?.preview))
  };
}
